
const state = {
    // 使用了逻辑或操作符|| ，如果左侧是真，则结果就是第一个并且不评估第二个
    // 如果第一个操作数是假，则表达式的结果将是第二个操作数的值。
    // '' 是一个空字符串，它被视为假值
    id: 0 || sessionStorage.getItem('id'),
    uid: 0 || sessionStorage.getItem('uid'),
    roles: 0|| sessionStorage.getItem('roles'),
    lasttime:0|| sessionStorage.getItem('lasttime'),
    username: '' || sessionStorage.getItem('username'),
    isCollapse: JSON.parse(sessionStorage.getItem('isCollapse')) || false,
    realname: '' || sessionStorage.getItem('realname'),
    tabs: [
        { path: '/main/sysLog', title: '后台首页' },
    ],
    tabsValue: '/main/sysLog',
    currentPath: '',//当前路由给菜单激活状态渲染用
}

const getters = {

}

const mutations = {
    //切换菜单折叠状态 取反
    SET_COLLAPSE(state) {
        state.isCollapse = !state.isCollapse;
        sessionStorage.setItem('isCollapse', JSON.stringify(state.isCollapse));
    },
    // 设置用户id
    SET_ID(state, val) {
        state.id = val;
    },
    // 设置用户uid
    SET_UID(state, val) {
        state.uid = val;
    },
    // 设置 lasttime
    SET_LASTTIME(state, val) {
        state.lasttime = val;
    },
    // 设置用户roles
    SET_ROLES(state, val) {
        state.roles = val;
    },
    // 设置用户名
    SET_USERNAME(state, val) {
        state.username = val;
    },
    // 设置真名
    SET_REALNAME(state, val) {
        state.realname = val;
    },
    // 设置动态标签数组
    ADD_TABS(state, val) {
        // //处理带参数的
        // let l=val['path'].indexOf('?');//找到参数开始位置
        // if (l!==-1) {
        //     val['path']=val['path'].substr(0,l);
        // }
       

        if (state.tabs.findIndex(e => e.path === val['path']) === -1) {
            state.tabs.push({
                path: val['path'],
                title: val['title'],
            })
        } 
        // else {
        //     console.log('已经存在了');
        // }

        // console.log('ADD_TABS------', state, val);
        // console.log('TABS-Length----->', state.tabs.length);
        // console.log('TABS-[0]----->', state.tabs[0]);

        // 超过 6 个时删掉下标 1 的标签（保留首页在 0），避免 shift 误删首页
        if (state.tabs.length > 6) {
            state.tabs.splice(1, 1);
        }
    },

    SET_TABS_VALUE(state, val) {
        state.tabsValue = val 
    },
    // 删除动态标签数组
    REMOVE_TABS(state, val) {
        const i = state.tabs.findIndex((e) => e.path === val);
        if (i !== -1) state.tabs.splice(i, 1);
    },
    // 退出登录等：恢复为默认首页标签，避免 tabs 为空导致无法再打开多页签
    CLEAR_TABS(state) {
        state.tabs.splice(0, state.tabs.length, {
            path: '/main/sysLog',
            title: '后台首页',
        });
        state.tabsValue = '/main/sysLog';
    },
    // 当前路由
    SET_CURRENT_PATH(state, val) {
        state.currentPath = val
        // console.log('state.currentPath--->',state.currentPath);
    },

}

const actions = {

}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}